import { useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface HelpTooltipProps {
  title: string;
  content: React.ReactNode;
}

export default function HelpTooltip({ title, content }: HelpTooltipProps) {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="d-flex align-items-center gap-2 help-icon ps-2">
      <OverlayTrigger
        placement="right"
        show={showTooltip}
        onToggle={(nextShow) => setShowTooltip(nextShow)}
        overlay={
          <Tooltip
            id={`${title}-tooltip`}
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
          >
            <span className="text-start">{content}</span>
          </Tooltip>
        }
      >
        <i className="material-symbols-outlined color-primary-hover">help</i>
      </OverlayTrigger>
    </div>
  );
}
